'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var AppliedFiltersBuilderFactory = function AppliedFiltersBuilderFactory(RsqlQuery, rsqlQueryService, momentService) {
  function AppliedFiltersQueryBuilder(filters) {
    var findAll = function findAll(array, prop, value) {
      var result = [];
      for (var i = 0, len = array.length; i < len; i++) {
        if (array[i][prop] === value) {
          result.push(array[i]);
        }
      }
      return result;
    };
    var processGroupNode = function processGroupNode(item) {
      var queryBuilder;
      var children = findAll(filters, 'parentIndex', item.index);
      var processedChildren = _.map(children, processItem);
      if (item.name === 'AND') {
        queryBuilder = new RsqlQuery().and();
        queryBuilder = queryBuilder.andGroup.apply(queryBuilder, processedChildren);
      } else if (item.name === 'OR') {
        queryBuilder = new RsqlQuery().or();
        queryBuilder = queryBuilder.orGroup.apply(queryBuilder, processedChildren);
      }
      return queryBuilder;
    };
    var processLeafNode = function processLeafNode(item) {
      var createMultiQuery = function createMultiQuery() {
        var prepareArrayForMultiQuery = function prepareArrayForMultiQuery() {
          return item.inputFilter.split(',');
        };
        var method = rsqlQueryService.getRsqlOperator(item.filterOperator, []);
        var queryBuilder = new RsqlQuery().is(item.dbPath);
        return queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(prepareArrayForMultiQuery()));
      };
      var createSingleQuery = function createSingleQuery() {
        var convertInputToItemType = function convertInputToItemType(property) {
          if (item.type === 'INTEGER') {
            return parseInt(item[property]);
          }
          if (item.type === 'FLOAT') {
            return parseFloat(item[property]);
          }
          return item[property];
        };
        var buildEqualDateTimeQuery = function buildEqualDateTimeQuery() {
          var getNextDayDate = function getNextDayDate(inputDate) {
            var date = momentService.of(inputDate, momentService.FIELD.DATA_EXTRACT_APPLIED_FILTERS);
            return date.add(1, 'days');
          };
          var filterInputValue = convertInputToItemType('inputFilter');
          var ge = rsqlQueryService.getRsqlOperator('>=', filterInputValue);
          var geQueryBuilder = new RsqlQuery().is(item.dbPath);
          geQueryBuilder[ge].call(geQueryBuilder, rsqlQueryService.formatOperand(filterInputValue, (0, _typeof2["default"])(filterInputValue)));
          var nextDayDate = getNextDayDate(filterInputValue);
          var lt = rsqlQueryService.getRsqlOperator('<', filterInputValue);
          var ltQueryBuilder = new RsqlQuery().is(item.dbPath);
          ltQueryBuilder[lt].call(ltQueryBuilder, rsqlQueryService.formatOperand(nextDayDate, (0, _typeof2["default"])(filterInputValue)));
          var queryBuilder = new RsqlQuery().and();
          return queryBuilder.andGroup.apply(queryBuilder, [geQueryBuilder, ltQueryBuilder]);
        };
        var isEqualDateTimeQuery = function isEqualDateTimeQuery() {
          return item.type === 'DATETIME' && item.filterOperator === '=';
        };
        var buildSimpleQuery = function buildSimpleQuery() {
          var filterInputValue = convertInputToItemType('inputFilter');
          var method = rsqlQueryService.getRsqlOperator(item.filterOperator, filterInputValue);
          var queryBuilder = new RsqlQuery().is(item.dbPath);
          return queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(filterInputValue, (0, _typeof2["default"])(filterInputValue)));
        };
        var buildDTDQuery = function buildDTDQuery() {
          var filterInputValue = convertInputToItemType('inputFilter');
          var method = rsqlQueryService.getRsqlOperatorByType(item.filterOperator, 'dtd');
          var queryBuilder = new RsqlQuery().is(item.dbPath);
          return queryBuilder[method].call(queryBuilder, rsqlQueryService.formatOperand(filterInputValue, (0, _typeof2["default"])(filterInputValue)));
        };
        if (isEqualDateTimeQuery()) {
          return buildEqualDateTimeQuery();
        } else if (item.type === 'DTD') {
          return buildDTDQuery();
        } else {
          return buildSimpleQuery();
        }
      };
      var isMultiOperator = function isMultiOperator() {
        return item.filterOperator === 'In' || item.filterOperator === 'Not in';
      };
      return isMultiOperator(item) ? createMultiQuery() : createSingleQuery();
    };
    var processItem = function processItem(item) {
      var isGroupRootNode = function isGroupRootNode() {
        return item.name === 'AND' || item.name === 'OR';
      };
      return isGroupRootNode() ? processGroupNode(item) : processLeafNode(item);
    };
    this.query = function () {
      return filters.length > 0 ? processItem(filters[0]).query() : '';
    };
  }
  return AppliedFiltersQueryBuilder;
};
AppliedFiltersBuilderFactory.$inject = ['RsqlQueryFactory', 'RsqlQueryService', 'MomentService'];
module.exports = AppliedFiltersBuilderFactory;